import { StartLoadOCMAction, START_LOAD_OCM_ACTION } from './ocm.types';

export const startOCMLoad = (): StartLoadOCMAction => ({
  type: START_LOAD_OCM_ACTION,
});
